import { render, staticRenderFns } from "./Qian10daMobile.vue?vue&type=template&id=2ad55b00&scoped=true&"
import script from "./Qian10daMobile.vue?vue&type=script&lang=js&"
export * from "./Qian10daMobile.vue?vue&type=script&lang=js&"
import style0 from "./Qian10daMobile.vue?vue&type=style&index=0&id=2ad55b00&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad55b00",
  null
  
)

export default component.exports